export const HomewearDetailsForm = {
  title: 'Homewear details',
  display: 'Homewear',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Comment',
          type: 'text',
          key: ['comment'],
          pos: {
            col: 1,
            row: 1,
            size: 1,
          },
        },
      ],
    },
  ],
}
